import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAuthSellerDealerData, IAuthSellerRequest, IDppManagementPageData } from '../models/models'

export class ListAuthSellerDealerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authSeller/CheckAuthSellerDealers',
      requesterInfo,
    })
  }

  public async ListAuthSellerData(): Promise<IAuthSellerDealerData> {
    return await this.getAsync<IAuthSellerDealerData>()
  }
}
